import { TranslationProvider } from '@frontend/lang';
import { ModalProvider } from '@frontend/modal';
import { AccountStoreProvider, BrandingStoreProvider } from '@frontend/repository';
import { BrowserRouter } from 'react-router-dom';
import { ToastContainer } from 'react-toastify';

import { Authentication } from './authentication/authentication.component';
import NoAccountMessage from './no-account-message';
import Resolver from './utils/resolver';

export const DefaultProviders = (props: { children: React.ReactNode }) => {
    return (
        <TranslationProvider>
            <BrowserRouter>
                <BrandingStoreProvider>
                    <Authentication>
                        <AccountStoreProvider noAccountsMessage={<NoAccountMessage />}>
                            <Resolver>
                                <ModalProvider>{props.children}</ModalProvider>
                            </Resolver>
                        </AccountStoreProvider>
                    </Authentication>
                </BrandingStoreProvider>
                <ToastContainer />
            </BrowserRouter>
        </TranslationProvider>
    );
};

export default DefaultProviders;
